import { render, staticRenderFns } from "./render-change.vue?vue&type=template&id=d572527a&scoped=true"
import script from "./render-change.vue?vue&type=script&lang=js"
export * from "./render-change.vue?vue&type=script&lang=js"
import style0 from "./render-change.vue?vue&type=style&index=0&id=d572527a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d572527a",
  null
  
)

export default component.exports